export enum Gender {
    preferNotToAnswer,
    female,
    male
}


// WEBPACK FOOTER //
// ./src/enums/demographics/Gender.tsx